import React from "react";
import styles from "./About.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

function About() {
	return (
		<section className={cx("about")} id="about">
			<h2 className={cx("title")}>
				About TV Remote: Universal Remote
			</h2>
			<p className={cx("body")}>
				TV Remote: Universal Remote is developed by Starnest JSC.
				<br />
				<br />
				The application transforms your Android device into a convenient remote control for compatible Smart TVs. Control your TV, enter text, search by voice, mirror your screen, and cast supported content directly from your mobile device.
			</p>
		</section>
	);
}

export default About;
